import { render, staticRenderFns } from "./DrmView.vue?vue&type=template&id=53345600&"
import script from "./DrmView.vue?vue&type=script&lang=js&"
export * from "./DrmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports